<div class="modal-header">
    <div class="row">
        <div class="col-2">
            <app-branding-logo-display [useDefaultLogo]="true"></app-branding-logo-display>
        </div>
        <div class="col-8 text-center">
            <h4 class="modal-title"><b>Proof Of Delivery</b></h4>
        </div>
        <div class="col-2">
            <div class="text-end"><button type="button" class="btn btn-outline-secondary"
                    (click)="activeModal.close('Close click')">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal-body">

    @if(isLoading || !orderPodData){
    <h4>
        Loading...
    </h4>
    }@else{
    <div class="eye-view-grid-wrapper">
        <div class="row">
            <div class="col-6 mb-2">
                <h5><strong>Consignee Details</strong></h5>
                <div class="row eye-view-consignor-row">
                    <div class="col-3 mogo-bold eye-view-consignor-header">
                        Name
                    </div>
                    <div class="col-9 eye-view-consignor-content">
                        {{ orderPodData.consigneeName}}
                    </div>
                </div>
                <div class="row eye-view-consignor-row">
                    <div class="col-3 mogo-bold eye-view-consignor-header">
                        Address
                    </div>
                    <div class="col-9 eye-view-consignor-content">
                        {{ orderPodData.consigneeAddress}}
                    </div>
                </div>
                <div class="row ">
                    <div class="col-3 mogo-bold eye-view-consignor-header">
                        Status
                    </div>
                    <div class="col-9 eye-view-consignor-content">
                        {{deliveryStatus}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-3 mogo-bold eye-view-consignor-header">
                        Signed By
                    </div>
                    <div class="col-9 eye-view-consignor-content">
                        {{orderPodData.signatureName}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-3 mogo-bold eye-view-consignor-header">
                        Driver
                    </div>
                    <div class="col-9 eye-view-consignor-content">
                        {{orderPodData.driverName }}
                    </div>
                </div>
            </div>
            <div class="col-6 mb-2">
                <h5><strong>Delivery Details</strong></h5>
                <div class="row eye-view-consignor-row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Delivered
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{orderPodData.deliveredDateTime}}
                    </div>
                </div>
                <div class="row eye-view-consignor-row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Manifest
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{orderPodData.manifestNumber}}/{{orderPodData.orderLoad}}
                    </div>
                </div>
                <div class="row ">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Order Number
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{orderPodData.orderNumber}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Reference Number
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{orderPodData.referenceNumber}}
                    </div>
                </div>
                <div class="row ">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Carrier
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{orderPodData.carrier}}
                    </div>
                </div>
                <div class="row ">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Truck
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{orderPodData.truck}}
                    </div>
                </div>
            </div>
        </div>

        @if(orderPodData && orderPodData.deliveryLocation){
        <div class="col-12 mb-2">
            <div #deliverylocationmap id="delivery-location-map" style="height: 200px;"></div>
        </div>
        }

        <div class="col-12 mb-4">
            <h5><strong>Proof of Deliveries</strong></h5>
            @if(isPodImageLoading){
                <div class="d-flex">
                    <div
                        class="spinner-grow text-highlight-color m-3"
                        role="status"
                    >
                    </div>
                    <p class="mogo-bold mt-4">Loading...</p>
                </div>
            }@else {
                @if(orderImagesString && orderImagesString.length > 0){
                    <div class="row">
                        @for(image of orderImagesString; track $index){
                        @if(image && image.contentType === 'application/pdf'){
                        <div class="col-1 text-center">
                            <a
                                [href]="image.href"
                                target="_blank"
                            >
                                <i
                                    class="b-fa b-fa-file-pdf b-fa-3x"
                                    aria-hidden="true"
                                ></i>
                            </a>
                        </div>
                        }@else {
                        <div class="col-1">
                            <a
                                [href]="image.href"
                                target="_blank"
                            >
                                <img
                                    width="90"
                                    [src]="image.base64"
                                    alt="Proof of Delivery"
                                />
                            </a>
                        </div>
                        }
                        }
                    </div>
                }@else {
                    <p class="mogo-bold">No POD image to show</p>
                }
            }
        </div>

        <div class="col-12 mb-4">
            <h5><strong>Product Details</strong></h5>
            <table class="table">
                <thead>
                    <tr>
                        <th class="mogo-bold mogo-bg-lightgray">
                            Category
                        </th>
                        <th class="mogo-bold mogo-bg-lightgray">
                            Description
                        </th>
                        <th class="mogo-bold mogo-bg-lightgray">
                            Units
                        </th>
                        <th class="mogo-bold mogo-bg-lightgray">
                            EQP
                        </th>
                        <th class="mogo-bold mogo-bg-lightgray">
                            Weight (kg)
                        </th>
                        <th class="mogo-bold mogo-bg-lightgray">
                            Volume (m3)
                        </th>
                    </tr>
                </thead>

                <tbody>
                    @for(orderProduct of orderPodData.orderProducts; track $index){
                    <tr>
                        <td>{{ orderProduct?.product?.productCategory?.name }}</td>
                        <td>{{ orderProduct.product?.name }}</td>
                        <td>{{ orderProduct.units }}</td>
                        <td>{{ orderProduct.eqp }}</td>
                        <td>{{ orderProduct.weight }}</td>
                        <td>{{ orderProduct.volume }}</td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>

        <div class="col-12">
            <h5><strong>Pallet Details</strong></h5>
            <table class="table">
                <thead>
                    <tr>
                        <th class="mogo-bold mogo-bg-lightgray">
                            CHEP
                        </th>
                        <th class="mogo-bold mogo-bg-lightgray">
                            LOSCAM
                        </th>
                        <th class="mogo-bold mogo-bg-lightgray">
                            Other
                        </th>
                        <th class="mogo-bold mogo-bg-lightgray">
                            Total
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>
                            {{ orderPodData.pallets?.chep }}
                        </td>
                        <td>
                            {{ orderPodData.pallets?.loscam }}
                        </td>
                        <td>
                            {{ orderPodData.pallets?.other }}
                        </td>
                        <td>
                            {{ orderPodData.pallets?.totalPallets }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    }
</div>
<div class="modal-footer">
    <div class="col-11 flex-fill">
        @if(sendEmailForm !== undefined && sendEmailForm !== null){
        <div class="flex-fill">
            <form [formGroup]="sendEmailForm" class="d-inline-flex w-50">
                <ng-select formControlName="recipients" [items]="[]" [addTag]="addTag" [multiple]="true"
                    [selectOnTab]="true" [isOpen]="false" placeholder="Enter email addresses"
                    notFoundText="Type to add a valid email" class="w-100">
                </ng-select>

                <button class="btn btn-primary" style="margin-left: 10px;" (click)="sendEmail()"
                    [disabled]="emailFormControl.value.length === 0">
                    Send
                </button>
            </form>
            <button type="button" class="btn btn-primary" style="margin-left: 10px;" (click)="downloadPodClick()">Download</button>
        </div>
        }

    </div>
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Close click')">Close</button>
</div>